<template>
  <router-view></router-view>
  <!-- <div class="flex flex-col min-h-screen">
    <TheNavbar />
    <main class="flex-grow">
      <router-view></router-view>
    </main>
    <TheFooter />
  </div> -->
</template>

<script>
// import TheNavbar from '@/components/TheNavbar.vue'
// import TheFooter from '@/components/TheFooter.vue'

export default {
  name: 'App',
  // components: {
  //   TheNavbar,
  //   TheFooter
  // },
  data() {
    return {
      isMobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    }
  },
  watch: {
    '$route'() {
      this.closeMobileMenu()
    }
  }
}
</script>